import React, { useEffect, useMemo } from 'react'
import styles from '../VNDialogs.module.scss'
import { useSelector } from 'react-redux'
import { getCFDBlockingDialog } from '../../Selectors'
import ConfirmModal from '../../../components/ConfirmModalV2'
import useSpinner from '../../../context/hooks/useSpinner'

/**
 * Non-dismissible dialog for when CFD is processing a transaction
 */
export const VNCFDBlockingDialog = () => {
  const message = useSelector(getCFDBlockingDialog)
  const isOpen = useMemo(() => !!message, [message])
  const { showSpinner, stopSpinner } = useSpinner()

  useEffect(() => {
    if (!message) return
    if (!showSpinner) return

    stopSpinner()
  }, [message, showSpinner, stopSpinner])

  if (!isOpen) {
    return null
  }

  return (
    <ConfirmModal
      classNames={{ container: styles.centered }}
      open={isOpen}
      singleButtonOnly
      headerText={message}
      emptyButtonContainer={true}
    />
  )
}
